import React from 'react';
import { Box, Typography } from '@material-ui/core';
import IntlMessages from 'util/IntlMessages';
import { SampleQueries } from './IllustrativeContent';

const History = ({ illustrative = false, maxHistory, maxItems = 4, hidden, ...props }) => {
  if (hidden) return null;
  if (illustrative) return <SampleQueries kind="history" maxItems={maxHistory || maxItems} />;

  const maxToShow = maxHistory || maxItems;
  // Deterministic width formula: 50 + (index * 17) % 50
  const getWidth = (i) => 50 + ((i * 17) % 60);

  return (
    <Box display="flex" flexDirection="column" gap={1} {...props}>
      <Typography variant="caption" style={{ color: '#9e9e9e', fontWeight: 600, paddingLeft: 4 }}>
        <IntlMessages id="ui.searchExperienceV2.core.blocks.history.recentSearches" />
      </Typography>

      <Box display="flex" flexDirection="column" gap={1}>
        {Array.from({ length: maxToShow }).map((_, i) => (
          <Box
            // eslint-disable-next-line react/no-array-index-key
            key={`history-${i}`}
            px={1.5}
            py={1}
            display="flex"
            alignItems="center"
            gap={1.5}
          >
            <Box width={14} height={14} bgcolor="#e0e0e0" borderRadius="50%" style={{ opacity: 0.5 }} />
            <Box width={getWidth(i)} height={8} bgcolor="#eeeeee" borderRadius={4} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default History;
